<template>
	<div class="mb-4">
		<CRow class="mb-3">
			<CCol lg="12">
				<span class="typo-label">
					{{ $t('message.channels') }}
				</span>
			</CCol>
		</CRow>
		<section class="container-channels px-3 pt-3 pb-2">
			<CRow class="m-0 mb-2">
				<CCol class="col-8">
					<span class="typo-label text-black-45">
						{{ $t('message.channels') }}
					</span>
				</CCol>
				<CCol class="col-4">
					<CRow>
						<CCol>
							<span class="typo-label text-black-45">
								{{ $t('message.allocation') }}
							</span>
						</CCol>
					</CRow>
				</CCol>
			</CRow>
			<CRow
				v-for="(item, index) in channels"
				:key="index"
				class="m-0 mb-3"
			>
				<CCol class="col-8 d-flex align-items-center">
					<span class="typo-body-2">
						{{ item.name }}
					</span>
				</CCol>
				<CCol class="col-4">
					<CRow>
						<CCol>
							<BaseInputNumber
								v-model="item.percentage"
								:disabled="disabled"
								append-text="%"
								text-align="left"
								class="w-100 ml-auto"
							/>
						</CCol>
					</CRow>
				</CCol>
			</CRow>
		</section>
		<section>
			<CRow>
				<CCol
					v-if="isValid === false"
					class="mt-1"
				>
					<div class="invalid-feedback d-block">
						{{ $t('message.allocation_is_required') }}
					</div>
				</CCol>
			</CRow>
		</section>
	</div>
</template>

<script>
import useAllocateChannel from '../use/allocateChannel';

export default {
	name: 'AllocationChannelList',

	props: {
		value: {
			type: Array,
			default: () => [],
		},
		total: {
			type: Number,
			default: 0,
		},
		isValid: {
			type: Boolean,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	setup(props, context) {
		const options = {
			defaultState: {
				channels: props.value,
				total: props.total,
			},
		};

		const {
			channels,
			transformChannels,
		} = useAllocateChannel(props, context, options);

		return {
			channels,
			transformChannels,
		};
	},
};
</script>

<style lang="scss" scoped>
.container-channels {
	background-color: $color-gray-100;
	border-radius: 4px;
}

ul {
	list-style: none;
	margin-left: 0;
	padding-left: 0;
}

li {
	padding-left: rem(8);
	text-indent: rem(-8);
}

li::before {
	content: "-";
	padding-right: rem(0);
	color: $color-black-45;
}
</style>
